class SearchBarComponent extends HTMLElement {
  constructor() {
    super();
    this.searchInput = null
    this.searchResults = null
    this.closeBtn = null
    this.header = null
  }

  connectedCallback() {
    this.searchInput = this.querySelector('input.search-input');
    this.searchResults = this.querySelector('.search_results');
    this.closeBtn = this.querySelector('.close-btn');
    this.header = this.closest("header")
    let timer;

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        this.header.classList.remove("search-active");
      });
    }

    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => {
        clearTimeout(timer);
        if (this.searchInput.value) {
          timer = setTimeout(() => this.fetchPredictiveSearch(this.searchInput.value, this.searchResults), 1000);
        } else {
          this.searchResults.innerHTML = '';
        }
      });
    }
  }

  fetchPredictiveSearch(query, resultsContainer) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then((resp) => resp.json())
      .then((data) => {
        const products = data.resources.results.products || [];
        resultsContainer.innerHTML = '';
        products.forEach((product) => {
          resultsContainer.innerHTML += `
            <div class="search-item-single">
              <a rel="nofollow" class="image-wrap" href="${product.url}" >
                <img style="width:100%;height:auto;" alt="${product.alt || ''}" src="${product.image}">
              </a>
              <div class="content">
                <h4>${product.title}</h4>
                <p>${newFormatMoney(product.price)}</p>
              </div>
            </div>`;
        });
      });
  }
}


if(!customElements.get('search-bar')){
    customElements.define('search-bar', SearchBarComponent);
}
